import { FC, useCallback, useMemo } from 'react';
import { Button, Card, RadixTable, TColumn } from '@features/ui';
import { ProductOffer } from '@src/types/productsAddons.ts';
import { cn } from '@lib/utils.ts';

interface ProductOtherDataProps {
  onEdit: (id: number) => void;
  data: ProductOffer[];
}
export const ProductOtherData: FC<ProductOtherDataProps> = ({
  data,
  onEdit,
}) => {
  const handleEdit = useCallback(
    (id?: number) => {
      if (!id) return;
      onEdit(id);
    },
    [onEdit]
  );

  const columns = useMemo(
    (): TColumn<ProductOffer>[] => [
      {
        title: '#',
        className: 'w-10',
        render: (_, index) => <p>{(index ?? 0) + 1}</p>,
      },
      {
        title: 'Title',
        render: (item) => <p>{item?.title}</p>,
      },
      {
        title: 'Status',
        render: (item) => {
          return (
            <div
              className={cn(
                item?.is_active ? 'bg-lime' : 'bg-[#DC342E]',
                'h-[21px] pl-[10px] pr-[9px] w-fit flex items-center rounded-[2px] text-xs leading-[1.5]'
              )}
            >
              <p>{item?.is_active ? 'Active' : 'Inactive'}</p>
            </div>
          );
        },
      },
      {
        title: '',
        render: (item) => (
          <div className={'flex'}>
            <Button
              className={'w-[58px]'}
              size={'sm'}
              variant={'secondary'}
              onClick={() => handleEdit(item?.id)}
            >
              Edit
            </Button>
          </div>
        ),
      },
    ],
    [handleEdit]
  );

  return (
    <Card className={'mt-[27px] pl-[18px] pr-[24px]'}>
      <RadixTable columns={columns} data={data} />
    </Card>
  );
};
